import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b18b000"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-summary" }
const _hoisted_2 = { class: "item first" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "copy" }
const _hoisted_7 = {
  id: "detailVal",
  style: {"width":"0","height":"0","opacity":"0"}
}
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "item" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "content" }
const _hoisted_23 = { class: "text" }

import HelperTools from "@/utils/helper";
import t from "@/utils/en";
import { ElMessage } from "element-plus";
import Clipboard from "clipboard";
import { ElIcon } from "element-plus";
import { ArrowRight, ArrowLeft, CopyDocument } from "@element-plus/icons";

interface Props {
  number: number;
  time: number;
  gasUsed: number;
  gasLimit: number;
  difficulty: number;
  height: number;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    number: null,
    time: null,
    gasUsed: null,
    gasLimit: null,
    difficulty: null,
    height: null
  },
  emits: ["nextBlock", "previousBlock"],
  setup(__props: any, { emit }: { emit: ({
    (e: "nextBlock"): void;
    (e: "previousBlock"): void;
  }), expose: any, slots: any, attrs: any }) {



const copyDetailVal = () => {
  let clipboard = new Clipboard(".copy-success");
  clipboard.on("success", function (e) {
    e.clearSelection();
  });
  copied();
};
const copied = () => {
  ElMessage(t.message.copysuccess);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("block.height")) + ":", 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(HelperTools).toFinancialVal(__props.number)), 1),
        _createVNode(_unref(ElIcon), { size: 16 }, {
          default: _withCtx(() => [
            _createVNode(_unref(CopyDocument), {
              size: 16,
              class: "el-icon-copy-document copy-success",
              "data-clipboard-target": "#detailVal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (copyDetailVal()))
            })
          ]),
          _: 1
        }),
        _createElementVNode("span", {
          class: "last clickable",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('previousBlock')))
        }, [
          _createVNode(_unref(ElIcon), { size: 16 }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowLeft), { size: 16 })
            ]),
            _: 1
          })
        ]),
        (__props.height > __props.number)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "next clickable",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('nextBlock')))
            }, [
              _createVNode(_unref(ElIcon), { size: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowRight), { size: 16 })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(__props.number), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("block.time")) + ":", 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(HelperTools).getTransDate(__props.time)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("block.gaslimit")) + ":", 1),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(HelperTools).toFinancialVal(__props.gasLimit)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("block.gasused")) + ":", 1),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, _toDisplayString(__props.gasUsed), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("block.difficulty")) + ":", 1),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("span", _hoisted_23, _toDisplayString(__props.difficulty), 1)
      ])
    ])
  ]))
}
}

})